module.exports = __webpack_public_path__ + "img/BannerCompras.b951a54b.png";